import { defineMessages } from 'react-intl';

const uyoMessages = defineMessages({
    uyoGuidLinesPopupTitle: {
        id: 'giftCardDetailsPage.uyoGuidLinesPopup.title',
        description: 'Title for upload your own photo popup',
        defaultMessage: 'Upload your own photo'
    },
    uyoGuidLinesPopupGuideline1: {
        id: 'giftCardDetailsPage.uyoGuidLinesPopup.guideline1',
        description: 'Guideline about file size and formats',
        defaultMessage: 'Up to 10MB with file format .jpg, .jpeg, .jfif, .png, or .webp.'
    },
    uyoGuidLinesPopupGuideline2: {
        id: 'giftCardDetailsPage.uyoGuidLinesPopup.guideline2',
        description: 'Guideline about prohibited content',
        defaultMessage: 'No logos, personal details, offensive or copyrighted content.'
    },
    uyoGuidLinesPopupReadTerms: {
        id: 'giftCardDetailsPage.uyoGuidLinesPopup.readTerms',
        description: 'Button text to read terms and conditions',
        defaultMessage: 'Read our Image Guidelines'
    },
    uyoGuidLinesPopupForFullDetails: {
        id: 'giftCardDetailsPage.uyoGuidLinesPopup.forFullDetails',
        description: 'Text after the read terms button',
        defaultMessage: 'for full details.'
    },
    uyoGuidLinesPopupCheckbox: {
        id: 'giftCardDetailsPage.uyoGuidLinesPopup.checkbox',
        description: 'Checkbox label for agreeing to terms',
        defaultMessage: 'I agree to the Image Guidelines for photo upload'
    },
    uyoGuidLinesPopupCheckboxUncheckedError: {
        id: 'giftCardDetailsPage.uyoGuidLinesPopup.checkboxUncheckedError',
        description: 'Label for not agreeing to terms',
        defaultMessage: 'Error: Please accept the Image Guidelines to continue'
    },
    uyoGuidLinesPopupCancel: {
        id: 'giftCardDetailsPage.uyoGuidLinesPopup.cancel',
        description: 'uyo guid lines popup cancel button',
        defaultMessage: 'Cancel'
    },
    uyoGuidLinesPopupUploadImage: {
        id: 'giftCardDetailsPage.uyoGuidLinesPopup.uploadImage',
        description: 'uyo guid lines popup upload image button',
        defaultMessage: 'Choose photo'
    },
    termsTitle: {
        id: 'giftCardDetailsPage.termsPopup.title',
        description: 'Terms and Conditions popup title',
        defaultMessage: 'Upload your own image guidelines'
    },
    imageGuidelinesIntro: {
        id: 'giftCardDetailsPage.termsPopup.imageGuidelinesIntro',
        description: 'Intro text for image guidelines',
        defaultMessage: 'BY UPLOADING AN IMAGE USING THIS SITE, YOU AGREE TO BE BOUND BY THESE GUIDELINES.You may only submit images for which you own all rights. You hereby grant to Blackhawk, its affiliates and sublicensees (including third-parties who provide the service and related services) a nonexclusive, royalty-free, worldwide license to use your uploaded image to create a gift card.'
    },
    imageLicense: {
        id: 'giftCardDetailsPage.termsPopup.imageLicense',
        description: 'License text for uploaded images',
        defaultMessage: 'We review all images submitted and reserve the right to deny an image for any reason at our sole discretion, including if it contains:'
    },
    prohibitedCopyright: {
        id: 'giftCardDetailsPage.termsPopup.prohibitedCopyright',
        description: 'Copyrighted logos, IP, or brand references',
        defaultMessage: '• Copyright protected logo, patent, trademark, artwork or other intellectual property material'
    },
    prohibitedWatermarks: {
        id: 'giftCardDetailsPage.termsPopup.prohibitedWatermarks',
        description: 'Watermarks or text-in-image',
        defaultMessage: '• Watermarks or text-in-image'
    },
    prohibitedInsensitive: {
        id: 'giftCardDetailsPage.termsPopup.prohibitedInsensitive',
        description: 'Culturally/socially insensitive imagery',
        defaultMessage: '• Culturally, racially  or socially insensitive images'
    },
    prohibitedOffensive: {
        id: 'giftCardDetailsPage.termsPopup.prohibitedOffensive',
        description: 'Libelous, defamatory, or offensive content',
        defaultMessage: '• Libelous, derogatory, or defamatory content'
    },
    prohibitedUnsafe: {
        id: 'giftCardDetailsPage.termsPopup.prohibitedUnsafe',
        description: 'Alcohol, drugs, weapons, or unsafe activity',
        defaultMessage: '• Alcohol, drugs, weapons, violence, or dangerous or unlawful activity'
    },
    prohibitedNudity: {
        id: 'giftCardDetailsPage.termsPopup.prohibitedNudity',
        description: 'Nudity or graphic/dead animal content',
        defaultMessage: '• Offensive, discriminative or pornographic content'
    },
    prohibitedCelebrities: {
        id: 'giftCardDetailsPage.termsPopup.prohibitedCelebrities',
        description: 'Celebrities, athletes, or fictional characters as the focus',
        defaultMessage: '• Celebrities, athletes, actors, cartoons or computer game figures'
    },
    footerNote: {
        id: 'giftCardDetailsPage.termsPopup.footerNote',
        description: 'Footer note for blocked images',
        defaultMessage: 'If you believe your image is being blocked incorrectly, please contact Customer Support using the link in the site footer.'
    },
    gotIt: {
        id: 'giftCardDetailsPage.termsPopup.gotIt',
        description: 'Got it button',
        defaultMessage: 'Got it'
    },
    uyoChooseFileTitle: {
        id: 'giftCardDetailsPage.uyoPopup.uyoChooseFileTitle',
        description: 'Title for file upload section',
        defaultMessage: 'Choose a file'
    },
    fileUploadingMessage: {
        id: 'giftCardDetailsPage.uyoPopup.fileUploadingMessage',
        description: 'Message displayed while a file is uploading',
        defaultMessage: 'Uploading...'
    },
    addToDesignMessage: {
        id: 'giftCardDetailsPage.uyoPopup.addToDesignMessage',
        description: 'Message displayed on uploaded image popup',
        defaultMessage: 'Add to design'
    },
    fileChangeMessage: {
        id: 'giftCardDetailsPage.uyoPopup.fileChangeMessage',
        description: 'Button text for changing the file',
        defaultMessage: 'Use a different image'
    },
    fileConfirmMessage: {
        id: 'giftCardDetailsPage.uyoPopup.fileConfirmMessage',
        description: 'Button text for confirming the file',
        defaultMessage: 'Next'
    },
    fileUploadErrorTitle: {
        id: 'giftCardDetailsPage.uyoPopup.fileUploadErrorTitle',
        description: 'Error message title for file upload failure',
        defaultMessage: 'Unable to upload'
    },
    fileUploadErrorMessage: {
        id: 'giftCardDetailsPage.uyoPopup.fileUploadErrorMessage',
        description: 'Error message for file upload failure',
        defaultMessage: 'This file type is not supported. Choose a .jpg, .png or .webp file (Maximum 10MB)'
    },
    editorEditButton: {
        id: 'giftCardDetailsPage.uyoPopup.editorEditButton',
        description: 'Button text for editing the uploaded file',
        defaultMessage: 'Edit'
    },
    editorAdjustButton: {
        id: 'giftCardDetailsPage.uyoPopup.editorAdjustButton',
        description: 'Button text for adjusting the uploaded file',
        defaultMessage: 'Adjust'
    },
    editorFiltersButton: {
        id: 'giftCardDetailsPage.uyoPopup.editorFiltersButton',
        description: 'Button text for applying filters to the uploaded file',
        defaultMessage: 'Filters'
    },
    uyoButtonText: {
        id: 'giftCardDetailsPage.uyoButtonText',
        description: 'Button Text for upload your own image popup',
        defaultMessage: 'Upload your own image'
    }
});

export default uyoMessages;
